export const ProjetosDB = [
    {
        id: 1,
        titulo: "Modelo de Predição de Dados Clínicos em Pacientes com Calazar baseado em Aprendizagem de Máquina.",
        meio: "CNPq",
        link: "http://lina.ufpi.br/kalacal/",
        data: "24/01/2024",
        text1: "A predição de valores baseados em AM em um ambiente de diagnóstico clínico possui caráter tecnológico e inovador, pois pode ajudar a melhorar a qualidade do atendimento ao paciente, reduzir erros e aumentar a eficiência do sistema de saúde. Uma plataforma eletrônica para auxílio à diagnóstico pode ajudar a garantir que os profissionais de saúde tenham acesso às informações do paciente, incluindo histórico médico, resultados de exames e outros dados importantes.",
        text2: "Estudar os diversos algoritmos de aprendizagem de máquina que melhor se adequem ao dados dos pacientes cadastrados no Kala-Cal, verificando assim a melhor opção em termos de performance e resultados na predição dos dados ausentes e incompletos.",
        icon: "fa fa-sitemap",
        status: "(em andamento)",
    }
  /*   {
        id: 2,
        titulo: "Artigo do Fungo2",
        meio: "Revista Brasileira de IA2",
        link: "http://google.com",
        data: "23/11/2021",
        text1: "Os Sistemas de Informação em Saúde (SIS) se configuram como uma estrutura capaz de garantir a obtenção e a transformação de  dados  em  informação.  Assim,  as  informações  são  coletadas,  processadas,  armazenadas e partilhadas com o objetivo de auxiliar no processo decisório em saúde, uma vez que contribui na produção de conhecimentos sobre as condições de vida e saúde da população, sobre morbimortalidade e  seus  fatores  de  risco,  entre  outros.  Assim  sendo,  a  utilização  dessas  informações  permite  a  otimização  dos  processos  gerenciais  e  assistenciais,  inclusive  no  cuidado  direto  ao  paciente,  o  que  possibilita  o  direcionamento de ações e recursos no enfrentamento dos problemas sanitários.",
        text2: "asdksjldj kj lkajl",
        icon: "fa fa-sitemap",
        status: "(Ativo)",
    } */
    
  ];
  